import { Antwort, ausschreibungStatus, AusschreibungStatus, type Leistung } from '../dtos';
import { sortAusschreibungStatus, sortExperteAntwort } from './sortVivaStatus.ts';
import { unique, uniqueBy } from './unique.ts';

type TeilleistungSkeleton = { leistung: Leistung };

export type TeilleistungColumn = {
  readonly teilleistungId: string;
  readonly label: string;
  readonly date?: string;
};

export function getAllLeistungen(teilleistungen: readonly { leistung: Leistung }[]): Leistung[] {
  const leistungen = teilleistungen.map((tl) => tl.leistung);
  return leistungen.filter(uniqueBy('leistungId'));
}

export function getSortedModulesForLeistung(
  modultermine: readonly {
    modul: { modulnummer: number };
    teilleistungen: readonly { teilleistungId: string; leistung: { leistungId: string } }[];
  }[],
  leistungId: string,
): TeilleistungColumn[] {
  return modultermine
    .toSorted((left, right) => left.modul.modulnummer - right.modul.modulnummer)
    .flatMap((modultermin) =>
      modultermin.teilleistungen
        .filter((teilleistung) => teilleistung.leistung.leistungId === leistungId)
        .map((teilleistung) => ({
          teilleistungId: teilleistung.teilleistungId,
          label: `Modul ${String(modultermin.modul.modulnummer)}`,
        })),
    );
}

export function getBestAntwort(leistung?: Leistung): Antwort {
  return leistung?.ausschreibung?.experteAntworten.toSorted(sortExperteAntwort).at(-1)?.antwort ?? 'keineAntwort';
}

export function getLowestAusschreibungStatus(teilleistungen: readonly TeilleistungSkeleton[]): AusschreibungStatus {
  return getAusschreibungStatuses(teilleistungen)[0] ?? ausschreibungStatus.KEINE_AUSSCHREIBUNG;
}

export function getNumberOfUniqueAusschreibungStatuses(teilleistungen: readonly TeilleistungSkeleton[]): number {
  return getAusschreibungStatuses(teilleistungen).length;
}

function getAusschreibungStatuses(teilleistungen: readonly TeilleistungSkeleton[]): AusschreibungStatus[] {
  return teilleistungen
    .map((tl) => tl.leistung.ausschreibung?.status ?? ausschreibungStatus.KEINE_AUSSCHREIBUNG)
    .filter(unique)
    .toSorted(sortAusschreibungStatus);
}
